import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IButtonProps } from '../Button/Button';
import { isMessageDescriptor } from '../helpers';

type ISecondaryButtonProps = IButtonProps;

const SecondaryButton: React.FunctionComponent<ISecondaryButtonProps> = ({ caption, dangerous, className, type = 'button', ...rest }) => {
    const attr = {
        className: classNames(
            'button',
            { 'button--secondary': !dangerous },
            { 'button--secondary-dangerous': dangerous },
            className,
        ),
        type,
        ...rest
    }

    return (
        isMessageDescriptor(caption) ?
            <FormattedMessage {...caption}>
                {(text) => <button {...attr}>{text}</button>}
            </FormattedMessage> :
            <button {...attr}>{caption}</button>
    );
}

export default SecondaryButton;